import {configureStore} from '@reduxjs/toolkit';
import loginReducer from '../slice/loginSlice';
import gasStationReducer from '../slice/gasStationSlice';
import profileReducer from '../slice/profileSlice';
import answerReducer from '../slice/answerSlice';
export const store = configureStore({
  reducer: {
    login: loginReducer,
    gasStation: gasStationReducer,
    profile: profileReducer,
    answer: answerReducer,
  },
});
